import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import Section from "~/components/Section";
export function ShowManagedByScim() {
    return (<Section sectionHeader="Managed by SCIM" className={managedByScimStyle}>
            <p>
                This user is managed by an external identity provider via <ExternalLink href="https://g.octopushq.com/Scim">System for Cross-domain Identity Management (SCIM)</ExternalLink>. Any changes you make may be overwritten.
            </p>
        </Section>);
}
const managedByScimStyle = css({
    paddingBottom: "1rem",
});
